import { useQuery } from '@tanstack/react-query';

import { getTooltips } from '@enterprise/api';
import { isNotDefined } from '@enterprise/core';

import { datastreamQueryKeys } from '@/common/query-keys';
import { useApplicationStore } from '@hooks/application/application-store.hook';

export const useGetTooltips = () => {
  const enterpriseApi = useApplicationStore(({ enterpriseApi }) => {
    return enterpriseApi;
  });

  return useQuery({
    queryFn: () => {
      return getTooltips(enterpriseApi);
    },
    queryKey: datastreamQueryKeys.tooltip.base,
    select: (result) => {
      if (result.failure) {
        return {};
      }

      return (result.data ?? []).reduce<Record<string, string>>((accumulator, { name, tooltip }) => {
        if (isNotDefined(tooltip)) {
          return accumulator;
        }

        accumulator[name] = tooltip;

        return accumulator;
      }, {});
    },
  });
};
